import { render, staticRenderFns } from "./ForumThreadEditorBody.vue?vue&type=template&id=31db22fa&scoped=true"
import script from "./ForumThreadEditorBody.vue?vue&type=script&lang=js"
export * from "./ForumThreadEditorBody.vue?vue&type=script&lang=js"
import style0 from "./ForumThreadEditorBody.vue?vue&type=style&index=0&id=31db22fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31db22fa",
  null
  
)

export default component.exports